<template>
    <!-- Small screens -->
    <div class="container-fluid px-0 d-md-none">
        <!-- Nav  -->
        <div class="d-flex align-items-center justify-content-between small-nav">
            <!-- Back icon -->
            <a class="navbar-brand fw-bold fs-4 py-0 m-0 cursor-pointer rounded-circle" v-load-page="'/'"
                :data-do-load="!settingPageOpen" @click="closeSettingPage($event)" v-ripple>
                <i class="bi-arrow-left"></i>
            </a>
            <!-- Title -->
            <p ref="smTitle" class="fs-5 fw-bold m-0">Settings</p>
            <!-- Menu toggler -->
            <i class="cursor-unset"></i>
        </div>
        <!-- Menu -->
        <nav ref="smMenu" class="navbar small-nav p-0 double-adjust">
            <div class="d-flex flex-column w-100">
                <div class="flex-grow p-0">
                    <ul class="navbar-nav mt-3">
                        <template v-for="settingsItem in settingsItems">
                            <li class="nav-item px-3 m-block-n1" @click="showSettingPage(settingsItem)" v-ripple>
                                <a class="p-big dropdown-item px-0 d-flex align-items-center cursor-pointer">
                                    <i class="cat-nav-icon me-3 w-auto" :class="settingsItem.iconClass"></i>
                                    {{ settingsItem.label }}
                                    <i class="ms-auto pe-0 w-auto" :class="settingsItem.iconRightClass"></i>
                                </a>
                            </li>
                            <li class="nav-item mx-3">
                                <hr class="dropdown-divider">
                            </li>
                        </template>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="mt-3 py-2 d-none" ref="smPage">
            <Account v-if="currPage === 'Account'"></Account>
	        <TwoFactorAuthentication v-if="currPage === 'Two Factor Authentication'"></TwoFactorAuthentication>
	        <SessionsAndTrustedDevices v-if="currPage === 'Sessions & Trusted Devices'"></SessionsAndTrustedDevices>

        </div>
    </div>

    <!-- Large screens -->
    <div class="container-fluid px-0 d-none d-md-block">
        <NavButtons light-btns></NavButtons>

        <!-- Title -->
        <h2 class="title fw-bold text-start">Settings</h2>

        <div class="divider sm"></div>
        <!-- Content -->
        <div class="row m-0">
            <!-- Menu -->
            <div class="col-4 col-md-5 col-lg-4 col-xl-3 p-0 mw-400">
                <div class="d-flex flex-column w-100">
                    <div class="flex-grow p-0">
                        <ul class="navbar-nav" role="tablist">
                            <template v-for="(settingsItem, index) in settingsItems">
                                <li class="nav-item pe-3 m-block-n1" role="presentation" v-ripple>
                                    <a class="dropdown-item p-0 d-flex align-items-center cursor-pointer"
                                       :class="index === 0 ? 'active' : ''" data-bs-toggle="tab"
                                       :data-bs-target="`#setting-${index}`" role="tab" type="button">
                                        <i class="ps-0 me-3" :class="settingsItem.iconClass"></i>
                                        {{ settingsItem.label }}
                                        <i class="ms-auto px-0 ms-auto w-auto move-right"
                                            :class="settingsItem.iconRightClass"></i>
                                    </a>
                                </li>
                                <li class="nav-item pe-3">
                                    <hr class="dropdown-divider">
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Content -->
            <div class="col-8 col-md-7 col-lg-8 col-xl-9 border-start p-4 pe-0 min-vh-100 w-capped">
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane" :class="index === 0 ? 'show active' : ''" :id="`setting-${index}`" role="tabpanel"
                         tabindex="0" v-for="(settingsItem, index) in settingsItems">
                        <component :is="settingsItem.component" ></component>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {ref} from "vue";
import Account from "@/components/Member/Settings/Account.vue";
import NavButtons from "@/components/NavButtons.vue";
import TwoFactorAuthentication from "@/components/Member/Settings/TwoFactorAuthentication.vue";
import SessionsAndTrustedDevices from "@/components/Member/Settings/SessionsAndTrustedDevices.vue";

const smTitle = ref(null);
const smMenu = ref(null);
const smPage = ref(null);
const settingPageOpen = ref(false);
const currPage = ref(null);

const settingsItems = [
    {
        iconClass: 'bi-person',
        label: 'Account',
        iconRightClass: 'bi-chevron-right ms-auto',
        component: Account
    },
	{
		iconClass: 'bi-shield-lock',
		label: 'Two Factor Authentication',
		iconRightClass: 'bi-chevron-right ms-auto',
		component: TwoFactorAuthentication
	},
	{
		iconClass: 'bi-pc-display',
		label: 'Sessions & Trusted Devices',
		iconRightClass: 'bi-chevron-right ms-auto',
		component: SessionsAndTrustedDevices
	},
]

const showSettingPage = (settingsItem) => {
    setTimeout(() => {
        settingPageOpen.value = true;
        currPage.value = settingsItem.label;
        smTitle.value.innerText = settingsItem.label;
        smMenu.value.classList.add("d-none");
        smPage.value.classList.remove("d-none");
    }, 600)
}

const closeSettingPage = (event) => {
    if (!settingPageOpen.value) return;
    setTimeout(() => {
        settingPageOpen.value = false;
        currPage.value = null;
        smTitle.value.innerText = "Settings";
        smMenu.value.classList.remove("d-none");
        smPage.value.classList.add("d-none");
    }, 600)
};
</script>

<style scoped lang="scss">
.double-adjust {
    margin: 0 -16px;
    margin-top: 10px;
}

.dropdown-divider {
    margin: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.175);
}

.dropdown-item {
    &:not(.p-big) {
        padding-bottom: 0.7em !important;
        padding-top: 0.7em !important;
    }

    &:hover {
        background-color: transparent !important;

        .move-right {
            transform: translateX(5px);
        }
    }

    .move-right {
        transition: transform 0.3s linear;
    }
}


.title {
    margin-top: 3.4rem;
    margin-bottom: 1em;
}

.mw-400 {
    max-width: 400px;
}

.nav-item.ripple {
    @media (min-width: 768px) {
        margin-left: -24px;
        padding-left: 24px;
    }

    @media (min-width: 1399px) {
        margin-left: -32px;
        padding-left: 32px;
    }
}

.w-capped {
    max-width: 50em;
}
</style>
